// extracted by mini-css-extract-plugin
module.exports = {"podcast":"IonoPodcast-module--podcast--2Du5X"};